module.exports = __webpack_public_path__ + "static/media/prinny-brave.3fc68adc.png";